import CircularRectTextButton, {
    CircularRectTextButtonProps,
} from "@/components/CircularButton/styled/CircularRectTextButton";
import { themeColors } from "@/utils/themeColors";

const LoadMoreBtn = ({ sx, ...props }: CircularRectTextButtonProps) => {
    return (
        <CircularRectTextButton
            sx={{
                backgroundColor: themeColors.primary,
                color: themeColors.primaryDark,
                borderRadius: "5rem",
                fontWeight: "600",
                fontSize: "1.8rem",
                padding: "1rem 2rem",
                ...sx,
            }}
            {...props}>
            {`Load more`}
        </CircularRectTextButton>
    );
};

export default LoadMoreBtn;
